import loadable from '@loadable/component';

export const UserInvitePageLoadable = loadable(
  () => import('./UserInvitePage'),
  { resolveComponent: (module) => module.UserInvitePage },
);
